import styled from 'styled-components'
import {
  white,
  blue,
  gray,
  grayDark,
  grayDarker,
  boxShadow,
} from '@bufferapp/ui/style/colors'

import { flexCol, flexRow, hideScrollBar } from '~/shared/styles/layout'
import { baseFont } from '~/shared/styles/font'

/**
 *
 */

export const Wrapper = styled.div`
  ${flexCol}
  width: 100%;
`

export const Row = styled.div`
  ${flexRow}
  width: 100%;
  margin-bottom: 8px;
  align-items: flex-start;
`

export const AvatarWrapper = styled.div`
  width: 32px;
  height: 32px;
  margin: 6px 8px 6px 0px;
`

export const ControlWrapper = styled.div`
  width: 100%;
  background-color: ${white};
  border-radius: 20px;
  padding: 10px 52px 10px 16px;
  box-shadow: 0px 0px 0px 3px ${boxShadow};
  border: 1px solid ${blue};
  position: relative;
`

export const Control = styled.div`
  margin: 0px;
  max-height: 64px;
  overflow-y: scroll;

  line-height: 0px;

  ${hideScrollBar}
`

export const Prefill = styled.span`
  color: ${gray};
  font-weight: 500;
  position: absolute;
  top: 0;
  left: 0;
  ${baseFont}
  line-height: 20px;
  font-weight: 500;
`

export const TextAreaLabel = styled.label`
  display: none;
`

export const TextArea = styled.textarea`
  width: 100%;
  border: none;
  outline: none;
  background: none;
  resize: none;
  text-indent: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'indent' does not exist on type 'ThemedSt... Remove this comment to see the full error message
    props.indent}px;
  ${baseFont}
  line-height: 20px;
  color: ${grayDarker};
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-x: hidden;

  ${hideScrollBar}
`

export const Button = styled.button`
  position: absolute;
  bottom: 8px;
  right: 8px;
  ${baseFont}
  font-weight: 500;
  color: ${gray};
  padding: 4px;
  background: none;
  border: none;
  cursor: pointer;

  &:hover {
    color: ${grayDark};
  }
`
